<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img">
      <div class="img_tit hidden-xs-only">{{ $t('carbonTreasure2.title') }}</div>
      <div class="img_tit hidden-sm-and-up">{{ $t('carbonTreasure2.mobileTitle') }}</div>
      <button class="learn-more" @click="toCBAM">{{ $t('auth.useDemo') }}</button>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="develop_wrap">
          <div class="develop_left">
            <h1>{{ $t('carbonTreasure2.whatIs.title') }}</h1>
            <p class="p2">{{ $t('carbonTreasure2.whatIs.description') }}</p>
            <ol class="outer-list">
              <li>{{ $t('carbonTreasure2.whatIs.coreObjectives.title') }}
                <ol class="inner-list">
                  <li v-for="(item, index) in $t('carbonTreasure2.whatIs.coreObjectives.items')" :key="index">{{ item }}</li>
                </ol>
              </li>
              <li>{{ $t('carbonTreasure2.whatIs.productScope.title') }}
                <ol class="inner-list">
                  <li v-for="(item, index) in $t('carbonTreasure2.whatIs.productScope.items')" :key="index">{{ item }}</li>
                </ol>
              </li>
              <li>{{ $t('carbonTreasure2.whatIs.geographicScope.title') }}
                <ol class="inner-list">
                  <li v-for="(item, index) in $t('carbonTreasure2.whatIs.geographicScope.items')" :key="index">{{ item }}</li>
                </ol>
              </li>
              <li>{{ $t('carbonTreasure2.whatIs.dataCollection.title') }}
                <ol class="inner-list">
                  <li v-for="(item, index) in $t('carbonTreasure2.whatIs.dataCollection.items')" :key="index">{{ item }}</li>
                </ol>
              </li>
              <li>{{ $t('carbonTreasure2.whatIs.carbonPrice.title') }}
                <ol class="inner-list">
                  <li v-for="(item, index) in $t('carbonTreasure2.whatIs.carbonPrice.items')" :key="index">{{ item }}</li>
                </ol>
              </li>
              <li>{{ $t('carbonTreasure2.whatIs.policyNature.title') }}
                <ol class="inner-list">
                  <li v-for="(item, index) in $t('carbonTreasure2.whatIs.policyNature.items')" :key="index">{{ item }}</li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div style="z-index:9;position:relative;display:none;">
      <Affix :offset-top="56">
        <Menu
          mode="horizontal"
          theme="light"
          :active-name="selectName"
          class="enter_menu_wrap"
          @on-select="selectMenuItem"
        >
          <MenuItem name="1" class="enter_menu_item">
            BioMall - 生物医药产业创新服务综合体
          </MenuItem>
          <MenuItem name="2" class="enter_menu_item">
            医疗器械创新示范基地
          </MenuItem>
        </Menu>
      </Affix>
    </div>
    <div class="current_show_menu">
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_center">
            <div class="enter_title">{{ $t('carbonTreasure2.evolutionTitle') }}</div>
          </div>
        </div>
      </div>
      <div class="mall_wrap">
        <div class="mall_img">
          <img :src="ybImg" alt="" />
        </div>
      </div>
      <div class="func_wrap">
        <div class="func_wrap_inner">
          <div class="func_tit">{{ $t('carbonTreasure2.impactTitle') }}</div>
          <el-row class="func_card hidden-xs-only" type="flex">
            <el-col
              class="card_item"
              v-for="(item, index) in funcCardList"
              :key="index"
              :span="5"
            >
              <div class="item_top" :style="{'background':`url(${item.bg})`}">
                <p>{{ item.tit }}</p>
              </div>
              <div class="item_bottom">
                <p v-for="(item2, index2) in item.desc" :key="index2">
                  {{ '○  ' + item2 }}
                </p>
              </div>
            </el-col>
          </el-row>
          <div
            v-for="index in 4"
            :key="index"
            class="func_card_mobile hidden-sm-and-up"
          >
            <img :src="getImagePath(index)" alt="" />
          </div>
        </div>
      </div>
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_center">
            <div class="enter_title">{{ $t('carbonTreasure2.serviceTitle') }}</div>
          </div>
        </div>
      </div>
      <div class="mall_wrap">
        <div class="mall_img">
          <img :src="yzsImg" alt="" />
        </div>
      </div>
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_center">
            <div class="enter_title">{{ $t('carbonTreasure2.reportTitle') }}</div>
          </div>
        </div>
      </div>
      <div class="mall_wrap">
        <div class="mall_img">
          <img :src="bgImg" alt="" />
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  data() {
    return {
      selectName: '1',
      funcCardList: [
        {
          tit: this.$t('carbonTreasure2.impacts.cost.title'),
          desc: this.$t('carbonTreasure2.impacts.cost.items'),
          bg: require('../../assets/img/bg1.png')
        },
        {
          tit: this.$t('carbonTreasure2.impacts.industry.title'),
          desc: this.$t('carbonTreasure2.impacts.industry.items'),
          bg: require('../../assets/img/bg2.png')
        },
        {
          tit: this.$t('carbonTreasure2.impacts.market.title'),
          desc: this.$t('carbonTreasure2.impacts.market.items'),
          bg: require('../../assets/img/bg3.png')
        },
        {
          tit: this.$t('carbonTreasure2.impacts.data.title'),
          desc: this.$t('carbonTreasure2.impacts.data.items'),
          bg: require('../../assets/img/bg3.png')
        },
      ],
      images_yb: {
        zh: require('@/assets/img/carbon/cbam-yb.png'),
        en: require('@/assets/img/carbon/cbam-yb-en.png')
      },
      images_yzs: {
        zh: require('@/assets/img/carbon/cbam-yzs.png'),
        en: require('@/assets/img/carbon/cbam-yzs-en.png')
      },
      images_bg: {
        zh: require('@/assets/img/carbon/cbam-bg.png'),
        en: require('@/assets/img/carbon/cbam-bg-en.png')
      }
    }
  },
  computed: {
    ybImg() {
      return this.images_yb[this.$i18n.locale] || this.images_yb.zh;
    },
    yzsImg() {
      return this.images_yzs[this.$i18n.locale] || this.images_yzs.zh;
    },
    bgImg() {
      return this.images_bg[this.$i18n.locale] || this.images_bg.zh;
    },
    isEn() {
      return this.$i18n.locale === 'en'; // 判断当前是否为英文
    },
  },
  watch: {
    '$i18n.locale': {
      handler: 'updateData',
      immediate: true
    }
  },
  methods: {
    getImagePath(index) {
      const suffix = this.isEn ? '-en' : '';
      return require(`@/assets/img/cbam-${index}${suffix}.png`);
    },
    selectMenuItem(name) {
      console.log(name)
    },
    gotoDemo(){
      this.$router.push('/trial')
    },
    toCBAM(){
      window.open('http://test.cbam.1clicktong.com/login', '_blank')
    },
    updateData() {
      this.funcCardList = [
        {
          tit: this.$t('carbonTreasure2.impacts.cost.title'),
          desc: this.$t('carbonTreasure2.impacts.cost.items'),
          bg: require('../../assets/img/bg1.png')
        },
        {
          tit: this.$t('carbonTreasure2.impacts.industry.title'),
          desc: this.$t('carbonTreasure2.impacts.industry.items'),
          bg: require('../../assets/img/bg2.png')
        },
        {
          tit: this.$t('carbonTreasure2.impacts.market.title'),
          desc: this.$t('carbonTreasure2.impacts.market.items'),
          bg: require('../../assets/img/bg3.png')
        },
        {
          tit: this.$t('carbonTreasure2.impacts.data.title'),
          desc: this.$t('carbonTreasure2.impacts.data.items'),
          bg: require('../../assets/img/bg3.png')
        },
      ]
    }
  },
  components: {
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../../assets/img/hly/new/关于我们/关于我们.jpg') 0 0 no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .learn-more {
      background: #f29c11;
      font-size: 20px;
      color: #fff;
      border: none;
      padding: 0.5rem 1.5rem;
      border-radius: 5px;
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 150%);
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
        margin-top: -1.5rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .production_inner {
      display: flex;
      justify-content: center;
      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }
        .production_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }
        .production_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .develop_wrap {
    width: 70%;
    margin: 0 auto;
    display: flex;
    @media screen and (max-width: 768px) {
      width: 90%;
      flex-direction: column;
      margin-bottom: 30px;
    }
    .develop_left {
      background-color: #f2f7ff;
      border-radius: 20px;
      padding: 20px;
      h1 {
        font-size: 26px;
        @media screen and (max-width: 768px) {
          font-size: 0.95rem;  
        }
      }
      .p2 {
        margin-top: 30px;
        font-size: 20px;
        color: #5b6e74;
        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }
    }
  }
  /* 外层列表 */
  .outer-list {
    padding-left: 20px;
    font-size: 17px;
    list-style-type: none;
    @media screen and (max-width: 768px) {
        font-size: 0.75rem;  
      }
  }

  /* 内层列表 */
  .inner-list {
    margin-left: 20px;
    padding-left: 20px;
    font-size: 16px;
    list-style-type: none;
    line-height: 2rem;
    @media screen and (max-width: 768px) {
        font-size: 0.75rem;  
      }
  }
  .outer-list > li::before {
    content: "• "; /* 添加自定义符号 */
    color: #000; /* 设置符号颜色 */
    margin-right: 10px; /* 控制符号和文字之间的间距 */
  }
  .inner-list > li::before {
    content: "\25CB"; /* 添加自定义符号 */
    color: #000; /* 设置符号颜色 */
    margin-right: 10px; /* 控制符号和文字之间的间距 */
  }
  .enter_menu_wrap {
    @media screen and (max-width: 768px) {
      height: 40px;
    }
    .enter_menu_item {
      width: 50%;
      text-align: center;
      font-size: 22px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .enter_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .enter_inner {
      display: flex;
      justify-content: center;
      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30%;
        }
      }
      .inner_center {
        // width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }
        .enter_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
            width: 23rem;
            text-align: center;
          }
        }
        .enter_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }
      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30%;
        }
      }
    }
  }
  .current_show_menu {
    .enter_card_wrap_mobile{
      width: 100%;
      img{
        width: 100%;
      }
    }
    .enter_card_wrap {
      width: 100%;
      margin-top: 50px;
      .enter_card_item {
        background: #f4f9fc;
        text-align: center;
        p {
          width: 60%;
          text-align: center;
          margin: 0 auto;
          font-size: 16px;
        }
        .title {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .mall_wrap {
      width: 70%;
      display: flex;
      justify-content: center;
      margin: 0px auto 40px;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      @media screen and (max-width: 768px) {
        flex-direction: column;
      }
      .mall_img {
        width: 80%;
        margin-right: 30px;
        padding: 0 30px;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
        img {
          width: 100%;
        }
      }
    }
    .mall_details {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media screen and (max-width: 768px) {
        width: 90%;
        text-align: center;
      }
      p {
        font-size: 20px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
      .mall_btn {
        margin-top: 40px;
        @media screen and (max-width: 768px) {
          padding: 20px 0;
        }
        .btn_self {
          background: orange;
          color: #fff;
          border-radius: 20px;
          border: none;
          @media screen and (max-width: 768px) {
            width: 80px;
            height: 35px;
            border-radius: 20px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .func_wrap {
    width: 100%;
    padding: 50px;
    background: url('../../assets/img/carbon/tan-bg.png');
    background-size: 100% 100%;
    .func_wrap_inner {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      .func_tit {
        font-size: 34px;
        font-weight: bold;
        text-align: center;
        color: #fff;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
      .func_card {
        justify-content: space-between;
        margin-top: 40px;
        .card_item {
          background: #fff;
          box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.1);
          .item_top {
            width: 100%;
            height: 150px;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
          }
          .item_bottom {
            padding: 15px;
            p {
              font-size: 16px;
              margin-top: 20px;
            }
          }
        }
      }
      .func_card_mobile{
        width: 100%;
        img{
          width: 100%;
          margin-top: 40px;
        }
      }
    }
    .double_card_wrap {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      .double_card {
        justify-content: space-between;
        margin-top: 50px;
        @media screen and (max-width: 768px) {
          flex-wrap: wrap;
        }
        .double_card_item {
          height: 250px;
          background: rgba($color: #fff, $alpha: 1);
          padding: 30px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          &:nth-child(1){
            background-image: url('../../assets/img/bg_1.png');
          }
          &:nth-child(2){
            background-image: url('../../assets/img/bg_2.png');
          }
          &:nth-child(3){
            background-image: url('../../assets/img/bg_3.png');
          }
          &:nth-child(4){
            background-image: url('../../assets/img/bg_4.png');
          }
          background-position: 100% 100%;
          background-repeat: no-repeat;
          background-size: 30%;
          @media screen and (max-width: 768px) {
            height: 140px;
            &:nth-child(n+3){
              margin-top: 20px;
            }
          }
          .double_card_bg {
            width: 30px;
            height: 15px;
            background: linear-gradient(90deg, rgba(252, 197, 96, 0), #feb15a);
            @media screen and (max-width: 768px) {
              width: 20px;
              height: 8px;
            }
          }
          p {
            line-height: 20PX;
            font-size: 15px;
            margin-top: 30px;
            @media screen and (max-width: 768px) {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}
</style>